import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApplicationCheckListType } from "../../Types/ChecklistTypes/ApplicationCheckListType";
import { getAllApplicationChecklist } from "../../Thunks/CheckListThunks";

interface ApplicationChecklistSliceState {
  loader: boolean; // for refres pages and inital loadings
  applicationChecklistData: ApplicationCheckListType[];
  errorDisplay: string | null;
}

// set inital valus
const initialState: ApplicationChecklistSliceState = {
  loader: false,
  applicationChecklistData: [],
  errorDisplay: "",
};

// handle api responces
const applicationChecklistSlice = createSlice({
  name: "applicationChecklistSlice",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getAllApplicationChecklist.rejected, (state, action) => {
        state.loader = false;
        state.errorDisplay = action.error.message!;
      })
      .addCase(getAllApplicationChecklist.pending, (state) => {
        state.loader = true;
        state.errorDisplay = null;
      })
      .addCase(
        getAllApplicationChecklist.fulfilled,
        (state, action: PayloadAction<ApplicationCheckListType[]>) => {
          state.loader = false;
          state.applicationChecklistData = action.payload;
        }
      );
  },
});

export const {} = applicationChecklistSlice.actions;
export default applicationChecklistSlice.reducer;
